import React from 'react'
import VoucherBookSearchSelect from './VoucherBookSearchSelect'
import { FieldLabel } from '../form/index'

const VoucherBookSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={VoucherBookSearchSelect} />
)

export default VoucherBookSearchSelectField
